<script>
	// From HeroIcons v1.0.5, "menu", outline
	export let iconClass = '';
</script>

<svg xmlns="http://www.w3.org/2000/svg" class={iconClass} fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" aria-hidden="true">
  <path stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 12h16M4 18h16" />
</svg>